import { makeAutoObservable, runInAction } from "mobx";
import { access_key, baseUrl } from "./main";

export default class Documents {
  files = [];
  offer = "";
  about = "";
  personalDataPolicy = "";
  error = false;
  isLoading = false;

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
  }

  getFiles = async () => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=files_for_candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          this.files = response["files"];
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  getStaticPage = async (value) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page_url", value);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=static_page`,
      {
        method: "POST",
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          switch (value) {
            case "personalDataPolicy":
              this.personalDataPolicy = response["static_page"]["value"];
              break;
            case "offerAgreement":
              this.offer = response["static_page"]["value"];
              break;
            case "about":
              this.about = response["static_page"]["value"];
              break;
            default:
              break;
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };
}
